import { IIdNameItem } from './IdNameItem';
import { LeasingCarCriteria } from './leasingCarCriteria';
import { Person } from './person';

// tslint:disable: variable-name
/**
 * It gathers the leasing form data:
 *  - selected options: both the id and the name are saved (for example locaton id and location name)
 *  - available options (for example, makes and models)
 *
 * When setting a field, its very next field must be reset. For example, when setting the location, the monthly fee is reset.
 */
export class LeasingCriteria {

    private _location: IIdNameItem;
    private _monthlyFee: number = null;
    private _carSpecs: LeasingCarCriteria[] = [];
    private _contactPerson: Person = new Person();
    
    locations: IIdNameItem[] = [];
    prefferedPhoneTimeIntervals: string[] = ['08-10', '10-12', '12-16', '16-18'];

    // optional fields that are populated only from page params when single municipality-make-model are provided
    private _singleMunicipality: number;
    private _singleCarMake: number;
    private _singleCarModel: number;

    constructor() {
        this.carSpecs.push(new LeasingCarCriteria());
    }

    get location(): IIdNameItem {
        return this._location;
    }

    set location(location: IIdNameItem) {
        this._location = location;
        this.monthlyFee = null;
    }

    set monthlyFee(monthlyFee: number) {
        if (this._monthlyFee != monthlyFee) {
            this._monthlyFee = monthlyFee;
            this._carSpecs = [];
        }
    }    

    get carSpecs(): LeasingCarCriteria[] {
        return this._carSpecs;
    }

    set carSpecs(carSpecs: LeasingCarCriteria[]) {
        this._carSpecs = carSpecs;
    }

    get contactPerson(): Person {
        return this._contactPerson;
    }

    set contactPerson(contactPerson: Person) {
        this._contactPerson = contactPerson;
    }
    
    get singleMunicipality(): number {
        return this._singleMunicipality;
    }

    set singleMunicipality(municipality: number) {
        this._singleMunicipality = municipality;
    }
    
    get singleCarMake(): number {
        return this._singleCarMake;
    }

    set singleCarMake(carMake: number) {
        this._singleCarMake = carMake;
    }
    
    get singleCarModel(): number {
        return this._singleCarModel;
    }

    set singleCarModel(carModel: number) {
        this._singleCarModel = carModel;
    }

    get monthlyFee(): number {
        return this._monthlyFee;
    }

}
